(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card-form')) {
    customElements.define(
      'product-card-form',
      class ProductCardForm extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.submitButton = this.form?.querySelector('[name="add"]');
          this.defaultLabel = this.submitButton?.textContent.trim();
          this.form?.addEventListener('submit', this.handleSubmit);
        }

        disconnectedCallback() {
          this.form?.removeEventListener('submit', this.handleSubmit);
          window.clearTimeout(this.resetTimer);
        }

        handleSubmit = async (event) => {
          event.preventDefault();

          if (!this.form || !this.submitButton || this.submitButton.disabled) return;

          this.submitButton.disabled = true;
          this.submitButton.setAttribute('aria-busy', 'true');
          this.submitButton.textContent = 'Adding…';

          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: new FormData(this.form),
            });
            const item = await response.json();

            if (!response.ok) throw new Error(item.description || 'Unable to add this item.');

            const cart = await this.getCart();
            this.submitButton.textContent = 'Added to cart';
            this.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { item, cart, source: this.submitButton } }));
          } catch (error) {
            this.submitButton.textContent = error.message || 'Try again';
          }

          this.submitButton.removeAttribute('aria-busy');
          this.resetTimer = window.setTimeout(() => {
            this.submitButton.disabled = false;
            this.submitButton.textContent = this.defaultLabel;
          }, 1800);
        };

        async getCart() {
          const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) throw new Error('Unable to refresh your cart.');
          return response.json();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
